import CommonApi from "../common/CommonApi";
import axios from "axios";
import SuccessResponse from "../dto/common/SuccessResponse";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import TicketListDto from "../dto/ticket/TicketListDto";
import TicketDetailDto from "../dto/ticket/TicketDetailDto";
import TicketSaveReqDto from "../dto/ticket/TicketSaveReqDto";
import TicketSaveRespDto from "../dto/ticket/TicketSaveRespDto";
import TicketUpdateReqDto from "../dto/ticket/TicketUpdateReqDto";
import TicketImageUploadRespDto from "../dto/ticket/TicketImageUploadRespDto";
import TicketStatusDto from "../dto/ticket/TicketStatusDto";
import TicketTrendDto from "../dto/ticket/TicketTrendDto";

class RealTicketApi extends CommonApi {
    async getTicketList({
        page,
        pageSize,
        remained,
    }: {
        page: number;
        pageSize: number;
        remained?: string;
    }): Promise<SuccessResponse<TicketListDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket`, {
            headers: baseHeaders,
        });

        const query: Record<string, any> = { page, pageSize };
        if (remained) {
            query.remained = remained;
        }

        const response = await axios.get<SuccessResponse<TicketListDto>>(`${this.BASE_SERVICE_URL}/ticket`, {
            headers: baseHeaders,
            params: query,
        });

        return response.data;
    }

    async getTicketDetail({ ticketNo }: { ticketNo: string }): Promise<SuccessResponse<TicketDetailDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket/detail`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<TicketDetailDto>>(`${this.BASE_SERVICE_URL}/ticket/detail`, {
            headers: baseHeaders,
            params: { ticketNo },
        });

        return response.data;
    }

    async saveTicket(
        reqDto: CommonRequestBodyDto<TicketSaveReqDto>
    ): Promise<SuccessResponse<TicketSaveRespDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket`, {
            headers: baseHeaders,
        });

        const response = await axios.post<SuccessResponse<TicketSaveRespDto>>(
            `${this.BASE_SERVICE_URL}/ticket`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async updateTicket(
        reqDto: CommonRequestBodyDto<TicketUpdateReqDto>
    ): Promise<SuccessResponse<Record<string, never>>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket`, {
            headers: baseHeaders,
        });

        const response = await axios.put<SuccessResponse<Record<string, never>>>(
            `${this.BASE_SERVICE_URL}/ticket`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async deleteTicket({ ticketNo }: { ticketNo: string }): Promise<SuccessResponse<Record<string, never>>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket`, {
            headers: baseHeaders,
        });

        const response = await axios.delete<SuccessResponse<Record<string, never>>>(
            `${this.BASE_SERVICE_URL}/ticket`,
            {
                headers: baseHeaders,
                params: { ticketNo },
            }
        );

        return response.data;
    }

    async uploadTicketImage({
        ticketNo,
        content,
    }: {
        ticketNo: string;
        content: File;
    }): Promise<SuccessResponse<TicketImageUploadRespDto>> {
        const baseHeaders = this.makeBaseHeader();

        const formData = new FormData();
        formData.append("content", content);

        await axios.options(`${this.BASE_SERVICE_URL}/ticket/image`, {
            headers: baseHeaders,
        });

        const response = await axios.post<SuccessResponse<TicketImageUploadRespDto>>(
            `${this.BASE_SERVICE_URL}/ticket/image`,
            formData,
            {
                headers: {
                    ...baseHeaders,
                    "Content-Type": "multipart/form-data",
                },
                params: { ticketNo },
            }
        );

        return response.data;
    }

    async deleteTicketImage({
        idTicketImage,
    }: {
        idTicketImage: number;
    }): Promise<SuccessResponse<Record<string, never>>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket/image`, {
            headers: baseHeaders,
        });

        const response = await axios.delete<SuccessResponse<Record<string, never>>>(
            `${this.BASE_SERVICE_URL}/ticket/image`,
            {
                headers: baseHeaders,
                params: { idTicketImage },
            }
        );

        return response.data;
    }

    async getTicketStatus(): Promise<SuccessResponse<TicketStatusDto>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket/status`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<TicketStatusDto>>(
            `${this.BASE_SERVICE_URL}/ticket/status`,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async getTicketTrend({
        periodType,
        today,
    }: {
        periodType: string;
        today: string;
    }): Promise<SuccessResponse<TicketTrendDto[]>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/ticket/trend`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<TicketTrendDto[]>>(
            `${this.BASE_SERVICE_URL}/ticket/trend`,
            {
                headers: baseHeaders,
                params: { periodType, today },
            }
        );

        return response.data;
    }
}

export default RealTicketApi;
